module.exports = __webpack_public_path__ + "static/media/main-node-with-child.6afda94c.svg";